var map = {
	"./AKanban.svg": 35401,
	"./Agile.svg": 10873,
	"./Analysis.svg": 20497,
	"./Analytic.svg": 94566,
	"./Appreciation.svg": 40622,
	"./Bill.svg": 47084,
	"./Brief Project.svg": 94018,
	"./Coaching.svg": 54317,
	"./Collaboration.svg": 68098,
	"./Contract.svg": 89553,
	"./Creativity.svg": 17089,
	"./Deployment.svg": 55594,
	"./File Security.svg": 805,
	"./Guide Book.svg": 19828,
	"./ID card.svg": 91626,
	"./Innovative.svg": 1638,
	"./List.svg": 747,
	"./Manager.svg": 14972,
	"./Message.svg": 340,
	"./Production.svg": 60038,
	"./Profile.svg": 47322,
	"./Schedule.svg": 96988,
	"./Skill.svg": 37122,
	"./Sprint.svg": 45215,
	"./Task flow.svg": 35564,
	"./Team Brainstorming.svg": 90709,
	"./Time Management.svg": 76437,
	"./Workflow.svg": 31512
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 77100;